import request from '@/config/axios'

// 续房管理 VO
export interface ExtensionOrderVO {
  id?: string | number
  shopId?: string | number
  originalOrderId: string | number
  extensionOrderId?: string | number
  extensionType: string // SAME_ROOM=同房续住 CHANGE_ROOM=换房续租
  originalCheckOutDate: string
  newCheckOutDate: string
  originalRoomId?: string | number
  newRoomId?: string | number
  extensionDays: number
  originalAmount: number
  newAmount: number
  diffAmount: number
  status: string // PENDING/CONFIRMED/PAID/CANCELLED
  createTime?: Date
}

// 获取续房分页
export const getExtensionOrderPage = (params: any) => {
  return request.get({ url: '/hotel/extension-order/page', params })
}

// 获取续房详情
export const getExtensionOrder = (id: string | number) => {
  return request.get({ url: '/hotel/extension-order/get?id=' + id })
}

// 创建续房
export const createExtensionOrder = (data: ExtensionOrderVO) => {
  return request.post({ url: '/hotel/extension-order/create', data })
}

// 更新续房
export const updateExtensionOrder = (data: ExtensionOrderVO) => {
  return request.put({ url: '/hotel/extension-order/update', data })
}

// 删除续房
export const deleteExtensionOrder = (id: string | number) => {
  return request.delete({ url: '/hotel/extension-order/delete?id=' + id })
}

// 批量删除续房
export const deleteExtensionOrderList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/extension-order/delete-list?ids=' + ids.join(',') })
}
